module.exports = __webpack_public_path__ + "static/WEDDING E&M-301-66a4ecdbaa38e1c6f515f44f9b54d6e9.jpg";